import { lazy, type ComponentType } from 'react';

/** Pause før det ene genforsøg af en fejlet side-import (kan overstyres i test). */
export const RETRY_DELAY_MS = { value: 400 };

/** Er fejlen en chunk, der ikke kunne hentes (fx 404 efter et nyt deploy)? */
export function isChunkLoadError(error: unknown): boolean {
  const text = `${(error as Error | null)?.name ?? ''} ${(error as Error | null)?.message ?? ''}`;
  return /dynamically imported module|importing a module script failed|ChunkLoadError|Loading chunk|Failed to fetch/i.test(
    text,
  );
}

/**
 * React.lazy med ét automatisk genforsøg. Efter et nyt deploy findes de gamle
 * hash-chunks ikke mere; et genforsøg hjælper ved kortvarige netfejl, mens en
 * vedvarende fejl når fanens fejlgrænse (TabErrorBoundary).
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  load: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    load().catch(
      (first: unknown) =>
        new Promise<{ default: T }>((resolve, reject) => {
          if (!isChunkLoadError(first)) {
            reject(first);
            return;
          }
          setTimeout(() => load().then(resolve, reject), RETRY_DELAY_MS.value);
        }),
    ),
  );
}
